export default {
  CrmBtnAgreementsAdd: 'CrmBtnAgreementsAdd',
  CrmBtnAgreementFileSend: 'CrmBtnAgreementFileSend',
  CrmBtnBalancePayment: 'CrmBtnBalancePayment',
  CrmBtnSendMail: 'CrmBtnSendMail',
  CrmBtnCreateCrm: 'CrmBtnCreateCrm',
  CrmBtnCreateCrmEvenIfImpersonated: 'CrmBtnCreateCrmEvenIfImpersonated',
  CrmBtnClientsImport: 'CrmBtnClientsImport',
  CrmBtnCrmDelete: 'CrmBtnCrmDelete',
  CrmBtnCrmEdit: 'CrmBtnCrmEdit',
  CrmBtnDownloadDebtors: 'CrmBtnDownloadDebtors',
  CrmBtnGoToCrmSection: 'CrmBtnGoToCrmSection',
  CrmBtnSwitchAccount: 'CrmBtnSwitchAccount',
  CrmBtnSwitchAccountAsIs: 'CrmBtnSwitchAccountAsIs',
  CrmBtnSwitchInactiveAccount: 'CrmBtnSwitchInactiveAccount',
  CrmBtnActivateCrm: 'CrmBtnActivateCrm',
  CrmBtnDeactivateCrm: 'CrmBtnDeactivateCrm',
  CrmBtnSystemBalanceManualRecharge: 'CrmBtnSystemBalanceManualRecharge',
  CrmBtnMailingSendNow: 'CrmBtnMailingSendNow',
  CrmBtnMailingDelete: 'CrmBtnMailingDelete',
  CrmBtnMailingEdit: 'CrmBtnMailingEdit',

  CrmPageCrmSectionList: 'CrmPageCrmSectionList',
  CrmPageCrmSectionAdd: 'CrmPageCrmSectionAdd',
  CrmPageCrmSectionEdit: 'CrmPageCrmSectionEdit',
  CrmPageTodoList: 'CrmPageTodoList',
  CrmPageAgreementsAdd: 'CrmPageAgreementsAdd',
  CrmPageAgreementsEdit: 'CrmPageAgreementsEdit',
  CrmPageAgreementsList: 'CrmPageAgreementsList',
  CrmPageAssignments: 'CrmPageAssignments',
  CrmPageCrmAdd: 'CrmPageCrmAdd',
  CrmPageCrmEdit: 'CrmPageCrmEdit',
  CrmPageCrmList: 'CrmPageCrmList',
  CrmPageMyAgreementsList: 'CrmPageMyAgreementsList',
  CrmPageSubscriptionPanel: 'CrmPageSubscriptionPanel',
  CrmPageSettlementsClientsList: 'CrmPageSettlementsClientsList',
  CrmPageSettlementsList: 'CrmPageSettlementsList',
  CrmPageBankingOperationsList: 'CrmPageBankingOperationsList',
  CrmPageMailingList: 'CrmPageMailingList',
  CrmPageMailingStepper: 'CrmPageMailingStepper',
  CrmPageBankingOperationsSettle: 'CrmPageBankingOperationsSettle',
  CrmPageTodoAllList: 'CrmPageTodoAllList',
  CrmPageAgreementReview: 'CrmPageAgreementReview',

  CrmFormCrmSaveDeletedItem: 'CrmFormCrmSaveDeletedItem',

  CrmSectionCrmAgreementsList: 'CrmSectionCrmAgreementsList',
  CrmSectionCrmAttendantList: 'CrmSectionCrmAttendantList',
  CrmSectionCrmIndustryName: 'CrmSectionCrmIndustryName',
  CrmSectionCrmRolesPreview: 'CrmSectionCrmRolesPreview',
  CrmSectionDownloadDebtors: 'CrmSectionDownloadDebtors',
  CrmSectionSystemBalancePuzzle: 'CrmSectionSystemBalancePuzzle',
  CrmSectionSystemBalanceDocuments: 'CrmSectionSystemBalanceDocuments',
  CrmSectionSystemBalanceDataUsage: 'CrmSectionSystemBalanceDataUsage',
  CrmSectionSystemBalancePrepaid: 'CrmSectionSystemBalancePrepaid',

  CrmAddNewAsIndustryTypeAo: 'CrmAddNewAsIndustryTypeAo',

  CrmPageBillingList: 'CrmPageBillingList',
  CrmPageBillingSettle: 'CrmPageBillingSettle',
};
